"use client";

import React, { useState } from "react";

import * as Icon from "@phosphor-icons/react/dist/ssr";

interface Props {
  props: string;
  slogan: string;
}

const TopNavOne: React.FC<Props> = ({ props, slogan }) => {
  const [isOpenLanguage, setIsOpenLanguage] = useState(false);
  const [isOpenCurrence, setIsOpenCurrence] = useState(false);
  const [language, setLanguage] = useState("English");
  const [currence, setCurrence] = useState("USD");

  return (
    <>
      <div className={`top-nav md:h-[44px] h-[30px] ${props}`}>
        <div className="container mx-auto h-full">
          <div className="top-nav-main flex justify-between max-md:justify-center h-full">
            <div className="left-content flex items-center gap-5 max-md:hidden">
              <div
                className="choose-type choose-language flex items-center gap-1.5"
                onClick={() => {
                  setIsOpenLanguage(!isOpenLanguage);
                  setIsOpenCurrence(false);
                }}
              >
                <div className="select relative">
                  <p className="selected caption2 text-white">{language}</p>
                  <ul
                    className={`list-option bg-white ${
                      isOpenLanguage ? "open" : ""
                    }`}
                  >
                    {["English", "Espana", "France"].map((item, index) => (
                      <li
                        key={index}
                        className="caption2"
                        onClick={() => setLanguage(item)}
                      >
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
                <Icon.CaretDown size={12} color="#fff" />
              </div>
              <div
                className="choose-type choose-currency flex items-center gap-1.5"
                onClick={() => {
                  setIsOpenCurrence(!isOpenCurrence);
                  setIsOpenLanguage(false);
                }}
              >
                <div className="select relative">
                  <p className="selected caption2 text-white">{currence}</p>
                  <ul
                    className={`list-option bg-white ${
                      isOpenCurrence ? "open" : ""
                    }`}
                  >
                    {["USD", "EUR", "GBP"].map((item, index) => (
                      <li
                        key={index}
                        className="caption2"
                        onClick={() => setCurrence(item)}
                      >
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
                <Icon.CaretDown size={12} color="#fff" />
              </div>
            </div>
            <div className="text-center text-button-uppercase text-white flex items-center">
              {slogan}
            </div>
            <div className="right-content flex items-center gap-5 max-md:hidden">
              <a href={"https://www.facebook.com/"} target="_blank">
                <i className="icon-facebook text-white"></i>
              </a>
              <a href={"https://www.instagram.com/"} target="_blank">
                <i className="icon-instagram text-white"></i>
              </a>
              <a href={"https://www.youtube.com/"} target="_blank">
                <i className="icon-youtube text-white"></i>
              </a>
              <a href={"https://twitter.com/"} target="_blank">
                <i className="icon-twitter text-white"></i>
              </a>
              <a href={"https://pinterest.com/"} target="_blank">
                <i className="icon-pinterest text-white"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopNavOne;
